import { useQueryClient } from "react-query";
import { CheckCircle } from "phosphor-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "../../../../../components/Button";
import { useAuth } from "../../../../../contexts/AuthContext";
import { DialogModal } from "../../../../../components/DialogModal";
import { useExpertBankDataMutation } from "../../../../../services/hooks/experts/mutations/useExpertBankData";
import { useExpertQuery } from "../../../../../services/hooks/experts/queries/useExpertQuery";
import { BankDataForm } from "../../../../../components/Forms/BankDataForm";
import register3 from "../../../../../assets/images/register-3.png";

interface Props {
  onGoPreviousStep: () => void;
}

export const BankData = ({ onGoPreviousStep }: Props) => {
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useExpertBankDataMutation();
  const { user } = useAuth();
  const { data } = useExpertQuery(user?.id!);

  const [isSuccessFeedbackModalOpen, setIsSuccessFeedbackModalOpen] =
    useState(false);

  const onSaveExpert = (values: any) => {
    Object.assign(values, { paymentType: data?.paymentType });

    if (data?.id) {
      mutate(
        { id: user?.id!, data: values },
        {
          onSuccess(data) {
            queryClient.setQueryData(["expert", user?.id!, "bank-data"], {
              bank: data.bank,
              currentAccount: data.currentAccount,
              bankBranch: data.currentAccount,
            });
            queryClient.invalidateQueries("expert");
            setIsSuccessFeedbackModalOpen(true);
          },
        }
      );
    }
  };

  return (
    <section className="md:py-5">
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="hidden md:block w-1/4">
            <img src={register3} alt="Text with image" />
          </div>
          <div className="w-full md:w-3/4 md:ps-8">
            <div className="mb-10">
              <h2 className="mb-6 text-2xl font-semibold">
                {formatMessage({ id: "REGISTER_BANK_DATA" })}
              </h2>

              <p className="mb-4 font-normal text-grey-800 max-w-[622px]">
                {formatMessage({ id: "FINISH_YOUR_BANK_ACCOUNT_REGISTRATION" })}
              </p>
            </div>

            <BankDataForm
              isSubmitting={isLoading}
              defaultValues={data?.bankData || undefined}
              onSubmit={onSaveExpert}
              userId={user?.id}
              onGoPreviousStep={onGoPreviousStep}
            />
          </div>

          <DialogModal
            isOpen={isSuccessFeedbackModalOpen}
            onClose={() => setIsSuccessFeedbackModalOpen(false)}
          >
            <div className="pb-10">
              <header className="mb-14">
                <CheckCircle
                  size={78}
                  className="mx-auto mb-16 text-primary-light"
                />

                <strong className="block font-normal text-center">
                  {formatMessage({ id: "REGISTRATION_COMPLETED_SUCCESSFULLY" })}
                </strong>
              </header>

              <footer className="mx-auto w-60">
                <Button onClick={() => navigate("/expert")} fullWidth>
                  {formatMessage({ id: "CONTINUE" })}
                </Button>
              </footer>
            </div>
          </DialogModal>
        </div>
      </div>
    </section>
  );
};
